let swatches = document.querySelectorAll('.bike-grid--product .swatches a.swatch');

swatches.forEach(swatch => swatch.addEventListener('click', (e) => {
  e.preventDefault();
  let swatch = e.currentTarget.closest('.swatch');
  let bikeGridProduct = e.currentTarget.closest('.bike-grid--product');

  // remove all active swatches
  bikeGridProduct.querySelectorAll('.swatch .swatch__label').forEach(s => s.classList.remove('is-selected'));

  // update content
  swatch.querySelector('.swatch__label').classList.add('is-selected');
  bikeGridProduct.querySelector('.bike-grid--product__image').src = swatch.dataset.productImage;
  bikeGridProduct.querySelector('.bike-grid--product__price').innerHTML = swatch.dataset.productPrice;

  if(bikeGridProduct.querySelector('.bike-grid--product__compare-at-price')){
    bikeGridProduct.querySelector('.bike-grid--product__compare-at-price').innerHTML = swatch.dataset.productCompareAtPrice;
  }

  bikeGridProduct
    .querySelectorAll('.bike-grid--product__link, .bike-grid--product__title, .bike-grid--product__add-to-cart a')
    .forEach(a => a.href = swatch.dataset.productUrl);
}));

window.addEventListener('prodigy:anchor-link-clicked', (event) => {
  const detail = event.detail;
  if(detail.target.querySelector('details')){
    detail.target.querySelector('details').open = true;
  }
});
